/**
 * Sistem postası sözleşmesi (M7 T2; K-M7-02). Platformun kendi posta yolu: davet ve parola sıfırlama iletileri. Tenant'ın kendi
 * SMTP hesabıyla giden e-postalardan (`email.ts`, M5 WP 5.4) AYRIDIR ve ona bağlı değildir.
 *
 * Durumlar üç ayrı olguyu karıştırmaz:
 *  - kuyruğa alınma (`queued`): ileti gönderim kuyruğunda; henüz hiçbir sunucuya verilmedi.
 *  - sağlayıcının kabulü (`provider_accepted`): posta sağlayıcısı (SMTP) iletiyi kabul etti. Alıcının gelen kutusuna ulaştığı
 *    ANLAMINA GELMEZ; alıcıya teslim bu sistemde izlenmez (geri dönen ileti otomatik işlenmez).
 *  - gönderilmedi: `failed` (sağlayıcı reddetti / ulaşılamadı), `not_configured` (sistem postası yapılandırılmamış),
 *    `uncertain` (ileti aktarıldıktan sonra yanıt alınamadı; otomatik yeniden gönderilmez), `sink` (sınama alıcısı — gerçek
 *    alıcıya gönderim yapılmadı), `held` (inceleme bekliyor).
 */
import { z } from 'zod';
export const SYSTEM_MAIL_STATUSES = [
    'queued',
    'provider_accepted',
    'failed',
    'not_configured',
    'uncertain',
    'sink',
    'held',
];
export const systemMailStatusSchema = z.enum(SYSTEM_MAIL_STATUSES);
/** Bir sistem iletisinin (ör. davet) posta durumu — yalnız sınıf; hata metni, alıcı ya da bağlantı taşımaz */
export const systemMailDeliverySchema = z.object({ status: systemMailStatusSchema });
/** `POST /auth/invite` yanıtı: davet oluşturuldu + iletinin o andaki posta durumu (kuyruk; "gönderildi" iddiası yoktur) */
export const inviteResultSchema = z.object({
    userId: z.guid(),
    mail: systemMailDeliverySchema,
});
/** Sistem postası kipi (süreç yapılandırması): gerçek gönderim · sınama alıcısı (yalnız üretim dışı) · yapılandırılmamış */
export const SYSTEM_MAIL_MODES = ['smtp', 'sink', 'unconfigured'];
/**
 * Hazır ucundaki (`/ready`) bilgi alanı. Zorunlu denetim DEĞİLDİR: `status` ve `checks` bundan etkilenmez (posta
 * yapılandırılmamış bir ortam "hazır değil" sayılmaz). `deliverable` yalnız gerçek gönderim kipinde `true`dur.
 */
export const systemMailReadinessSchema = z.object({
    mode: z.enum(SYSTEM_MAIL_MODES),
    deliverable: z.boolean(),
    detail: z.string(),
});
//# sourceMappingURL=system-mail.js.map